import { render } from "./TabsContent.vue?vue&type=template&id=1cb2db8c"
import script from "./TabsContent.vue?vue&type=script&lang=js"
export * from "./TabsContent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nikita/Documents/works/novosel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__